import { render, staticRenderFns } from "./Minipro.vue?vue&type=template&id=789ffd00&"
import script from "./Minipro.vue?vue&type=script&lang=js&"
export * from "./Minipro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports